<template>
  <Datepicker 
    ref="datepickerRef"
    @update:modelValue="handleDate"
    :class="{
      'week': weekpicker,
      'month': monthpicker,
      'small' : small
    }"
    :value="localDate"
    :start-date="startdate"
    weekStart="1"
    :day-names="daynames" 
    noToday
    :weekPicker="weekpicker" 
    :monthPicker="monthpicker"
    :locale="$i18n.locale" 
    cancelText="" 
    :year-range="yearrange"
    autoApply
    :enable-time-picker="false"
    selectText="Selecionar"
    inline>
      <template #calendar-header="{ index, day }">
          <div class="header-color">
            {{ day }}
          </div>
      </template>
  </Datepicker>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'DatePicker',
  props:["monthpicker","weekpicker","date","small"],
  emits:["dateSelected"],
  components:{
    Datepicker
  },
  data() {
    return {
      datepickerRef: null,
    }
  },
  computed: {
    daynames(){
      if(this.$i18n.locale == "pt"){
        return ['S','T','Q','Q','S','S','D']
      }
      return ['M','T','W','T','F','S','S'];
    },
    localDate: {
      get() {
        return this.date;
      },
      set(value) {
        this.$emit("update:date", value);
      },
    },
    startdate(){
      return this.localDate?.length > 0 ? this.localDate[0] : "";
    },
    yearrange(){
      const currentyear = new Date().getFullYear();
      return [currentyear-2,currentyear+2];
    }
  },
  watch: {
    date(newDate) {
      if (this.datepickerRef) {
        const datevalue = this.monthpicker ? newDate[1] : newDate;
        this.datepickerRef.updateInternalModelValue(datevalue);
      }
    }
  },
  mounted(){
    this.datepickerRef = this.$refs.datepickerRef;
  },
  methods: {
    handleDate(modelData){
      const currentMonth = this.weekpicker ? modelData[1].getMonth() : modelData.month;
      this.$emit('dateSelected',modelData,currentMonth);
    },
  }
}
</script>

<style>
.dp__overlay_col:focus-visible{
  outline: none !important;
}

.marked-cell{
  background-color: #2650e7;
  border-radius: 50%;
  color:white;
}

/* If you want to customize the light theme specifically */

:root{
  --dp-font-family: "PT Sans";
  --dp-border-radius: 6px;
}

/*dias*/
.dp__cell_inner.dp__pointer{
  font-family: "Montserrat Light";
  font-size: 14px;
}

/*meses*/
.dp__overlay_cell.dp__overlay_cell_pad,
.dp__overlay_cell_active.dp__overlay_cell_pad{
  font-family: "Montserrat";
}

.dp__btn.dp--year-select{
  font-family: "Montserrat Light";
}

.dp__calendar_header{
  font-family: "Montserrat Bold";
  font-size: 15px;
}

/*resto do calendario*/
.dp__month_year_row{
  font-family: "Montserrat Light";
}

.dp--menu--inner-stretched{
  padding-bottom: 0;
}

.dp__btn.dp__button.dp__overlay_action.dp__button_bottom:hover{
  border-radius: var(--dp-border-radius);
}

.dp__overlay_cell.dp__overlay_cell_pad:hover{
  border-radius: 40px;
  background-color: #f5f3f3;
  color:#2650e7;
}

.dp__overlay_container.dp__container_flex{
  height: auto !important;
}

.dp__theme_light {
  --dp-menu-border-color: transparent;
  --dp-border-color: transparent;
  z-index: 1;

}

.dp__overlay_cell_pad{
  padding-top: 5px;
  padding-bottom: 5px;
}

.dp__overlay_cell_active{
  border-radius: 40px;
  background-color: #1976d2;
}

.dp__btn.dp__month_year_select,
.dp__overlay_cell.dp__overlay_cell_pad,
.dp__overlay_cell_active.dp__overlay_cell_pad{
  text-transform: lowercase;
}

.dp__overlay .dp__months .dp__month {
  flex-basis: calc(100% / 4); /* Divide 100% by 4 to display 4 months per row */
}

.small .dp__calendar_item{
  height: 25px;
  font-size: 13px;
}
</style>

<style scoped>

.header-color {
  color: #ccc;
}

img{
  width: 40px;
  height: 40px;
}
</style>